import React, { useEffect } from 'react'

import { Spinner } from '@acorns/web-components'
import { useUserId } from '@acorns/web-utils'
import styled from 'styled-components'

import { useRootUserQueryQuery } from 'generated/types'

const StyledContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`
/*
We are making a query to get the current user to cache our Preflight Response 
on app load to minimize the number or Preflight Responses made.
The data queried here is unimportant for this purpose (we just need to ping the server),
but we'll take this opportunity to set the user's uuid in React context for the UserIdProvider.
*/

export const PreflightWrapper: React.FC = ({ children }) => {
  const { loading, data } = useRootUserQueryQuery({
    fetchPolicy: 'network-only',
  })

  const { setUserId } = useUserId()

  useEffect(() => {
    const userId = data?.user?.uuid
    if (userId) {
      setUserId(userId)
    }
  }, [data, setUserId])

  if (loading) {
    return (
      <StyledContainer>
        <Spinner />
      </StyledContainer>
    )
  } else {
    return <div>{children}</div>
  }
}
